$(document).ready(() => {
  var $target = $('#shark_species_content');
  var $source = $('#shark_species_template');
  var anchor_shark_id = window.location.hash.substring(1);
  var $anchor_shark = null;

  // Push content for a specific element
  var populate = function ($button) {
    var url = $button.attr('data-url') + '?template=1';
    $.get(url, function (data) {
      var output = template(data);
      $target.html(output);
    });
  };

  // Populate $target when a shark item is clicked on
  if ($source.length) {
    var template = Handlebars.compile($source.html());
    $('.shark-species-gallery').on('click', '.shark-species', function () {
      populate($(this));
    });

    // Has the user requested a shark via a page anchor
    if (anchor_shark_id.length) {
      $anchor_shark = $('.shark-species[data-shark-id="' + anchor_shark_id + '"]');
    }

    if ($anchor_shark) {
      populate($anchor_shark);
    } else {
      // Default populate the first shark
      populate($($('.shark-species-gallery .shark-species')[0]));
    }
  }
});
